import {PremiumPaidUp as PremiumPaidUpLetter} from 'Agent/Policies/api/apiTypes';
import React from 'react';
import CardField from 'Shared/components/CardField';
import {toFormattedDateAsUTC} from 'Shared/utilities/DateFormatter';

export type PremiumPaidUpLetterProps = {
  premiumPaidUpLetter: PremiumPaidUpLetter;
};

const PremiumPaidUp = (props: PremiumPaidUpLetterProps) => {
  return (
    <>
      <CardField name={'Insured Name'} value={props.premiumPaidUpLetter.insuredName} ddprivacy="mask"/>
      <CardField name={'Owner Name'} value={props.premiumPaidUpLetter.ownerName} ddprivacy="mask"/>
      <CardField name={'Owner Address'} value={props.premiumPaidUpLetter.ownerAddress!.fullAddress} ddprivacy="mask"/>
      <CardField name={'Policy Number'} value={props.premiumPaidUpLetter.policyNumber} ddprivacy="mask"/>
      <CardField name={'Date'} value={toFormattedDateAsUTC(props.premiumPaidUpLetter.date)} />
      <CardField name={'Agent Number'} value={props.premiumPaidUpLetter.agentNumber} />
    </>
  );
};

export default PremiumPaidUp;
